import { __awaiter, __generator } from "tslib";
import Tabs from 'static-components/src/tabs';
import { STATE, StateHelper } from "Helper/StateHelper";
var initializeTabs = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, StateHelper.instance.readyStates(STATE.TRANSLATOR)];
            case 1:
                _a.sent();
                new Tabs();
                return [2 /*return*/];
        }
    });
}); };
export default initializeTabs;
